import * as XLSX from 'xlsx';

/** Download a sample Excel template for recipient import. */
export function downloadRecipientTemplate(): void {
  const rows = [
    ['email', 'name (optional)'],
    ['recipient@example.com', 'John Doe'],
    ['another@example.com', ''],
  ];
  const sheet = XLSX.utils.aoa_to_sheet(rows);
  sheet['!cols'] = [{ wch: 32 }, { wch: 24 }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Recipients');
  XLSX.writeFile(workbook, 'vedika-email-recipients-template.xlsx');
}
